<template>
  <div class="columns is-gapless contained-height-inter">
    <todo-list @refreshEvents="loadRunningOptions();loadRunningDenunciations();"></todo-list>
    <div class="columns column is-6-desktop is-5-widescreen is-7-fullhd
      is-block-desktop is-block-widescreen is-flex-fullhd dash-RightGroupCols">
      <small-calendar class="column is-12-desktop is-12-widescreen is-6-fullhd is-padding-top"></small-calendar>
      <div v-if="statsEnabled"
        class="column is-12-desktop is-12-widescreen is-6-fullhd is-order-last-fullhd is-padding-top">
        <dashboard-stats></dashboard-stats>
      </div>
    </div>
  </div>
</template>

<script>
  import { mapState, mapGetters } from 'vuex'
  import moment from 'moment'

  import TodoList from './TodoList'
  import SmallCalendar from './SmallCalendar'
  import DashboardStats from './DashboardStats'

  export default {
    name: 'DashboardAdmin',
    components: {
      TodoList,
      SmallCalendar,
      DashboardStats
    },
    props: {},
    data () {
      return {
        pendingDenunciations: [],
        pendingOptions: []
      }
    },
    computed: {
      ...mapState(['events', 'currentUser']),
      ...mapGetters(['orderedEvents']),
      statsEnabled () {
        return JSON.parse(this.$configs.STATS_ENABLED)
      }
    },
    methods: {
      reloadState () {
        this.loadEvents()
        this.loadReminders()
        this.loadRunningOptions()
        this.loadRunningDenunciations()
      },
      loadEvents () {
        this.$api.eventService.get().then(r => {
          this.$store.commit('setEvents', {events: r.data})
        })
      },
      loadReminders () {
        this.isLoadingReminders = true
        this.$api.reminderService.get().then(r => {
          let reminders = r.data.items
          reminders.forEach(x => {
            let date = moment(x.date)
            let key = date.format('DD/MM/YYYY')
            this.$store.commit('addCalendarEvent', {event: x, key: key, type: 'reminders'})
          })
        })
      },
      loadRunningOptions () {
        let query = {
          per_page: 100,
          status: ['pending', 'waiting_list', 'approved']
        }
        this.$api.optionService.get(query).then(res => {
          this.$store.commit('setRunningOptions', {options: res.data.items})
        })
      },
      loadRunningDenunciations () {
        let query = {
          per_page: 100,
          status: ['pending']
        }
        this.$api.denunciationService.get(query).then(res => {
          this.$store.commit('setRunningDenunciations', {denunciations: res.data.items})
        })
      },
      loadPendingDenunciationsCount () {
        let query = {
          per_page: 100,
          status: 'pending'
        }
        this.$api.denunciationService.get(query)
          .then(r => {
            this.pendingDenunciations = r.data.items
          })
      },
      loadPendingOptionsCount () {
        let query = {
          per_page: 100,
          status: 'pending'
        }
        this.$api.optionService.get(query)
          .then(r => {
            this.pendingOptions = r.data.items
          })
      }
    },
    created () {
      this.loadPendingDenunciationsCount()
      this.loadPendingOptionsCount()
      this.$scrollTo('#app', 0)
    }
  }
</script>

<style>


</style>



// WEBPACK FOOTER //
// src/components/home/dashboard-admin/DashboardAdmin.vue